/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notfound_Contact_SupportInputs */



/**
* | output |
* | --- |
* | "Contact support if you need help" |
*
* @param {Notfound_Contact_SupportInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notfound_contact_support = /** @type {((inputs?: Notfound_Contact_SupportInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notfound_Contact_SupportInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kontaktiere den Support, wenn du Hilfe benötigst")
	return /** @type {LocalizedString} */ ("Contact support if you need help")
});